__turbopack_context__.v({
  "fade-in": "WidgetForm-module-scss-module__wBLTCW__fade-in",
  "form": "WidgetForm-module-scss-module__wBLTCW__form",
  "formResponsive": "WidgetForm-module-scss-module__wBLTCW__formResponsive",
  "no-transform": "WidgetForm-module-scss-module__wBLTCW__no-transform",
  "rotate": "WidgetForm-module-scss-module__wBLTCW__rotate",
});
